import Box from "@mui/material/Box";
import { resource } from "../../utility/constants/resource/resource";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import MainContent from "../../MainContent/MainContent";

const MainArea = ({
  onClickArrow,
  currentMainArea,
  showLeftArrow,
  showRightArrow,
}: {
  onClickArrow?: (direction: string) => void;
  currentMainArea: any;
  showLeftArrow: boolean;
  showRightArrow: boolean;
}) => {
  return (
    <Box
      sx={{
        height: "100%",
        maxHeight: "100%",
        overflowY: "auto",
        "::-webkit-scrollbar": { display: "none" },
        borderRadius: "6px",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          maxHeight: "100%",
          overflowY: "auto",
          "::-webkit-scrollbar": { display: "none" },
        }}
      >
        <MainContent name={currentMainArea.name} />
      </Box>
      {showLeftArrow && (
        <Box
          onClick={() => {
            onClickArrow?.("left");
          }}
          sx={{
            position: "absolute",
            left: 0,
            // borderRight: `0.5px solid ${resource.colors.borderOutlineColor}`,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          <ArrowBackIosIcon
            fontSize="small"
            sx={{ margin: 1, color: resource.colors.defaultColor }}
          />
        </Box>
      )}
      {showRightArrow && (
        <Box
          onClick={() => {
            onClickArrow?.("right");
          }}
          sx={{
            position: "absolute",
            right: 0,
            height: "100%",
            // borderLeft: `0.5px solid ${resource.colors.borderOutlineColor}`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          <ArrowForwardIosIcon
            fontSize="small"
            sx={{ margin: 1, color: resource.colors.defaultColor }}
          />
        </Box>
      )}
    </Box>
  );
};
export default MainArea;
